import { Decorative } from "@faire/design-tokens";
import { Span } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { ComponentProps } from "react";

import { ExclusivityDetailsLink } from "./ExclusivityDetailsLink";
import { ExclusivityDetailsModal } from "./ExclusivityDetailsModal";

interface IProps {
  origin: ComponentProps<typeof ExclusivityDetailsModal>["origin"];
  agreementToken: string | undefined;
  brandToken: string | undefined;
}

export const ExclusivityLink: React.FC<IProps> = ({
  agreementToken,
  brandToken,
  origin,
}) => {
  return (
    <ExclusivityDetailsLink
      agreementToken={agreementToken}
      brandToken={brandToken}
      origin={origin}
      color={Decorative.shade.orange}
    >
      <Span
        color="inherit"
        variant={{
          mobileAndAbove: "labelSansMedium",
          desktopAndAbove: "paragraphSansMedium",
        }}
      >
        <StrictLocalMsg
          defaultMessage="Exclusivity"
          description={{
            text: "Exclusivity link",
            img: "https://cdn.faire.com/fastly/9f8456e63e716b4e583d5a8ed981ddc960129fb7005368ecd5f755670650f033.png",
          }}
        />
      </Span>
    </ExclusivityDetailsLink>
  );
};
